import React, { useState } from 'react';
import classnames from 'classnames';
import { ImQrcode } from 'react-icons/im';

import StyledQrCode from './StyledQrCode';
import Button from './Button';
import Container from './Container';
import Img from './Img';
import Qrcode from './qr-code.png';

function Logo () {
  const [visible, setVisible] = useState(false);
  
  function handleClick() {
    setVisible(!visible);
  }
  
  const iconStyle = {
    pointerEvents: 'none',
  };
  
  return (
    <>
      <StyledQrCode>
        <Button title="QR code" onClick={handleClick}>
          <ImQrcode style={iconStyle} size={30} />
        </Button>
      </StyledQrCode>
      <Container title="To run this game on your phone, open the Camera app and point your phone at the QR code" className={classnames({visible: visible})}>
        <Img src={Qrcode} alt="https://tetris-linuxmachine.vercel.app" />
      </Container>
    </>
  );
}

export default Logo;
